import React from 'react'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import UserPaymentButton from '../user-payment-button/UserButtonPayment'
import {
  ClientProposalOutputDto,
  ClientRequestOutputDto,
  Payment_Type,
} from '../../../../../../lib/graphql'
import { IProposalInteractionsProps } from '../../../Proposal'

interface IUserCanPayPostBalanceFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  handlePostBalancePayment?: () => void
  clientRequest: Pick<
    ClientRequestOutputDto,
    '_id' | 'adminCsm' | 'balancePostFinal'
  >
  clientProposal: Pick<
    ClientProposalOutputDto,
    | '_id'
    | 'userCurrentAction'
    | 'clientRequestId'
    | 'houseId'
    | 'permissions'
    | 'serviceProviderId'
  >
}

const UserCanPayPostBalanceFooter = ({
  adminActions,
  handlePostBalancePayment,
  clientProposal,
  clientRequest,
}: IUserCanPayPostBalanceFooterProps) => {
  const adminCanceledPostBalanceAdjustmentsConfirmation =
    adminActions?.adminCanceledPostBalanceAdjustmentsConfirmation

  if (!clientRequest.balancePostFinal?.status) {
    throw new Error('clientRequest.balance.status is required')
  }

  return (
    <>
      <div className='flex w-full flex-col gap-3 py-5'>
        <UserPaymentButton
          clientRequestId={clientRequest._id}
          houseId={clientProposal.houseId}
          serviceProviderId={clientProposal.serviceProviderId}
          payment={{
            paymentType: Payment_Type.BALANCE_POST_FINAL,
            paymentAmount:
              clientRequest.balancePostFinal?.price?.totalUser
                ?.priceWithDiscountAndFees?.priceWithVat ?? 0,
            paymentStatus: clientRequest.balancePostFinal?.status,
          }}
          handlePayment={handlePostBalancePayment}
        />

        {clientProposal.permissions.canCancelStepSeven &&
          adminCanceledPostBalanceAdjustmentsConfirmation && (
            <AdminActionButton
              adminAction={
                AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION
              }
              onClickConfirm={() =>
                adminCanceledPostBalanceAdjustmentsConfirmation.callback({
                  clientProposalId: clientProposal._id,
                })
              }
              isLoading={
                adminCanceledPostBalanceAdjustmentsConfirmation.isLoading
              }
            />
          )}
      </div>
    </>
  )
}

export default UserCanPayPostBalanceFooter
